var $ = require('jquery');
var ycmem = require('./ycmem');
var regUrl = 'http://mem.ycgame.com/reg.ashx';
var loginUrl = 'http://r.ycgame.com/UCLogin.ashx';
ycmem.base = "http://mem.ycgame.com/";

var EVENTS = {
    LOGIN: 'auth-login',
    LOGOUT: 'auth-logout',
    REGISTER: 'auth-register'
};
var Auth = function () {
    this._event = $(this);
    this.EVENTS = EVENTS;
};

Auth.prototype = {
    member: null,
    bind: function (event, callback) {
        this._event.bind.apply(this._event, arguments);
    },
    trigger: function (event, arg) {
        this._event.trigger.apply(this._event, arguments);
    },
    one: function (event, callback) {
        this._event.one.apply(this._event, arguments);
    },

    exists: function (val) {
        var isMobile = /^1\d{10}$/.test(val);
        return doCall('cmd=exist' + (isMobile ? '&v=m' : '') + '&u=' + val);
    },
    getVerifyCode: function (mobile, imgCaptcha) {
        return doCall('&cmd=getv&v=m&u=' + mobile + '&c=' + imgCaptcha);
    },
    getImgCodeSrc: function () {
        return 'http://mem.ycgame.com/captcha.ashx?&r=' + Math.random();
    },
    regUsername: function (username, password, realname, idcard, imgCapthca, prefix, g) {
        var host = document.domain;
        prefix = host.substr(0, (host.indexOf(".ycgame.com")));
        var data = '&cmd=reg&u=' + username + ycmem.getK(password, imgCapthca) + '&tn=' + encodeURIComponent(realname) + '&i=' + idcard + '&t=' + prefix + '&f=' + (g || '3') + '&icn=1';
        var self = this;
        return doCall(data).done(function (rs) {
            self.member = {username: username};
            self.trigger(EVENTS.LOGIN, ['register']);
            self.trigger(EVENTS.REGISTER, ['register']);
        });
    },
    regMobile: function (mobile, password, idcard, imgCapthca, smsCaptcha, type, f) {
        var data = "&cmd=reg&u=" + mobile + ycmem.getK(password, imgCapthca) + "&i=" + idcard + "&v=" + (type || 'm') + "&vc=" + smsCaptcha + "&f=" + (f || '32');
        var self = this;
        return doCall(data).done(function (rs) {
            self.member = {username: mobile};
            self.trigger(EVENTS.LOGIN, ['register']);
            self.trigger(EVENTS.REGISTER, ['register']);
        });
    },
    checkLogin: function () {
        var defer = $.Deferred();
        var self = this;
        $.ajax({
            type: "get",
            url: loginUrl,
            dataType: "jsonp",
            data: {
                frtype: ec("checklogin2"),
                k: ec(codeSign)
            },
            jsonp: "callbackparam"
        }).fail(function () {
            defer.reject();
        }).done(function (result) {
            if (result.ok === '1') {
                self.member = {username: result.name};
                self.trigger(EVENTS.LOGIN, ['check']);
                defer.resolve(self.member);
            } else {
                defer.reject(result);
            }
        });

        return defer;
    },

    logout: function () {
        var self = this;
        return $.ajax({
            type: "get",
            url: "http://r.ycgame.com/UCLogin.ashx",
            dataType: "jsonp",
            data: {frtype: ec("logout"), k: ec(codeSign)},
            jsonp: "callbackparam"
        }).done(function () {
            self.member = null;
            self.trigger(EVENTS.LOGOUT, ['logout']);
        });
    },
    login: function (username, password, captcha) {
        var defer = $.Deferred();
        var self = this;
        $.ajax({
            type: "get",
            url: loginUrl,
            dataType: "jsonp",
            data: {
                frvalue1: ec(username),
                frvalue2: ec(password),
                frvalue3: ec(captcha),
                frtype: ec('loginyan'),
                k: ec(codeSign)
            },
            jsonp: "callbackparam"
        }).fail(function () {
            defer.reject();
        }).done(function (result) {
            if (result.ok === '1') {
                self.member = {username: result.user};
                self.trigger(EVENTS.LOGIN, ['login']);
                defer.resolve(self.member);
            } else {
                defer.reject(result);
            }
        });

        return defer;
    }
};
var codeSign = "ycgamepsqlsdfngspzycgame";
function getKey() {
    var e = codeSign;
    if (e == "") {
        return 0;
    }
    var t = 0;
    for (var n = 0; n < e.length; n++)t += e.charCodeAt(n) * e.length;
    return t;
}
function ec(e) {
    var t = getKey(codeSign), n = "";
    for (var r = 0; r < e.length; r++) {
        var i = e.charCodeAt(r) + t;
        n += i + ","
    }
    return n.substring(n.length - 1, n.length) == "," && (n = n.substring(0, n.length - 1)), escape(n)
}
var doCall = function (data) {
    var defer = $.Deferred();
    $.ajax({
        url: regUrl,
        data: data,
        dataType: 'jsonp',
        jsonp: 'cb'
    }).fail(function () {
        defer.reject();
    }).done(function (rs) {
        //rs.ok == 22 接口问题
        if (rs.ok === 0) {
            defer.resolve(rs);
        } else {
            var msg = ycmem.getMsg(rs);
            defer.reject(rs, msg);
        }
    });

    return defer;
};

module.exports = new Auth();


//////////////////
// WEBPACK FOOTER
// ./auth.js
// module id = 2
// module chunks = 0